<template>
        <div v-if="atp && atp.grupo_etq_amostras && atp.grupo_etq_amostras.length > 0">
            <span v-if="atp.grupo_etq_amostras">
                <span v-for="(grupo, igx) in atp.grupo_etq_amostras" :key="igx" class="badge" :class="'badge-' + ( color ? color : 'primary') + ( !igx ? '' : ' ml-1' )" :title="grupo.tipo_etiqueta.st_titulo">
                    <i :class="grupo.tipo_etiqueta.st_icon" v-if="grupo.tipo_etiqueta.st_icon"></i>
                    <span v-else-if="grupo.tipo_etiqueta.st_sigla">
                        {{ grupo.tipo_etiqueta.st_sigla }}
                    </span>
                    <span v-else>
                        {{ grupo.tipo_etiqueta.st_titulo }}
                    </span>

                    <span class="ml-2">
                        {{ grupo.qt_itens }}
                    </span>
                </span>
            </span>
        </div>
</template>

<script>
export default {
    props: ['atp', 'color']
}
</script>
